import React from 'react';
import { ParkingSquare, Construction } from 'lucide-react';

const GlassPanel: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`bg-white/5 backdrop-blur-2xl border border-white/10 rounded-2xl overflow-hidden shadow-2xl p-6 ${className}`}>{children}</div>
);

export function ParkingManagement() {
  return (
    <div className="min-h-screen bg-[#0a0b14] text-white p-6 space-y-8 pb-32">
      <div>
        <h1 className="text-3xl font-black tracking-tighter uppercase flex items-center gap-3"><ParkingSquare className="w-8 h-8 text-blue-400" /> Parking Management</h1>
        <p className="text-sm text-blue-100/40 mt-1 font-medium tracking-wide">Zone occupancy and violation tracking across monitored parking areas.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <GlassPanel><p className="text-[10px] uppercase tracking-widest text-blue-100/40 font-bold mb-1">Total Capacity</p><h4 className="text-2xl font-black text-white">0</h4></GlassPanel>
        <GlassPanel><p className="text-[10px] uppercase tracking-widest text-blue-100/40 font-bold mb-1">Occupied</p><h4 className="text-2xl font-black text-white">0</h4></GlassPanel>
        <GlassPanel><p className="text-[10px] uppercase tracking-widest text-blue-100/40 font-bold mb-1">Available</p><h4 className="text-2xl font-black text-white">0</h4></GlassPanel>
      </div>

      <GlassPanel className="flex flex-col items-center justify-center text-center py-20">
        <div className="w-16 h-16 rounded-2xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-6">
          <Construction className="w-7 h-7 text-blue-400" />
        </div>
        <h3 className="text-sm font-black uppercase tracking-widest text-white mb-2">AI Model Not Yet Connected</h3>
        <p className="text-xs text-blue-100/40 max-w-md leading-relaxed">
          Zone-based parking occupancy detection needs a dedicated AI model that isn't wired up yet. This page is ready to display live spot-by-spot data the moment that model is integrated.
        </p>
      </GlassPanel>
    </div>
  );
}
